package amazon.lastmile.inject

import app.nestbridge.feature.messages.ui.MessagesUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = MessagesUiFactory::class)
public interface AppNestbridgeFeatureMessagesUiMessagesUiFactory {
  @Provides
  @IntoSet
  public fun provideMessagesUiFactoryFactoryMultibinding(messagesUiFactory: MessagesUiFactory): Ui.Factory = messagesUiFactory
}
